import { render, staticRenderFns } from "./chatMessages.vue?vue&type=template&id=0e308a24&scoped=true"
import script from "./chatMessages.vue?vue&type=script&lang=js"
export * from "./chatMessages.vue?vue&type=script&lang=js"
import style0 from "./chatMessages.vue?vue&type=style&index=0&id=0e308a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e308a24",
  null
  
)

export default component.exports